<app-header></app-header>
<app-sidebar
  ativo="Comunicacao"
></app-sidebar>
<div class="content-wrapper">
  <section class="content">
    <app-breadcrumb
      Titulo="Email"
      [TemPaginaPai] = true
      PaginaPai="Comunicação"
      Pagina="Email"
    ></app-breadcrumb>

    <div class="content p-0">
      <div class="d-md-flex">
        <div class="email-sidebar border-end border-bottom bg-white simplebar-scrollable-y" style="width: 380px; max-height: 80vh; overflow-y: auto;" data-simplebar="init">
          <div class="simplebar-wrapper">
            <div class="simplebar-height-auto-observer-wrapper">
              <div class="simplebar-height-auto-observer"></div>
            </div>
            <div class="simplebar-mask">
              <div class="simplebar-offset">
                <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content">
                  <div class="simplebar-content" *ngFor="let config of listaConfiguracoes">
                    <div class="p-3">
                      <div class="border bg-white rounded p-2 mb-3">
                        <div class="d-flex align-items-center ">
                          <div class="fundo-iniciais">{{ buscarIniciais(config.display || config.email) }}</div>
                          <div class="m-lg-2">
                            <h6 class="mb-1 fs-11 fw-medium"><a href="javascript:void(0);">{{ config.display || config.email  }}</a></h6>
                            <p class="fs-11 mb-0">{{ config.email }}</p>
                          </div>
                        </div>
                      </div>
                      <a href="javascript:void(0);" class="btn btn-primary w-100 text-white" id="compose_mail"><i class="fa fa-edit me-2"></i>Novo email</a>
                      <div class="mt-3">
                        <div class="d-block mb-3 pb-3 border-bottom">
                          <a href="javascript:void(0);" class="d-flex align-items-center justify-content-between p-2 rounded" [ngClass]="{'active': config.id === configIdAtual && selectedFolder === 'inbox'}"
                             (click)="listarEmailPorConfig(config.id, 'inbox')">
                            <span class="d-flex align-items-center fw-medium"><i class="fa fa-inbox text-gray me-2"></i>Caixa de entrada</span>
                            <span class="badge bg-danger rounded-pill badge-xs">{{ contarPorPasta(config.id, 'inbox') }}</span>
                          </a>
                          <a href="javascript:void(0);" class="d-flex align-items-center justify-content-between p-2 rounded" [ngClass]="{'active': config.id === configIdAtual && selectedFolder === 'sent'}"
                             (click)="listarEmailPorConfig(config.id, 'sent')">
                            <span class="d-flex align-items-center fw-medium"><i class="fa fa-rocket text-gray me-2"></i>Enviados</span>
                            <span class="rounded-pill">{{ contarPorPasta(config.id, 'sent') }}</span>
                          </a>
                          <a href="javascript:void(0);" class="d-flex align-items-center justify-content-between p-2 rounded" [ngClass]="{'active': config.id === configIdAtual && selectedFolder === 'drafts'}"
                             (click)="listarEmailPorConfig(config.id, 'drafts')">
                            <span class="d-flex align-items-center fw-medium"><i class="fa fa-file text-gray me-2"></i>Rascunhos</span>
                            <span class="rounded-pill">{{ contarPorPasta(config.id, 'drafts') }}</span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="simplebar-placeholder"></div>
          </div>
          <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
          </div>
          <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
            <div class="simplebar-scrollbar" style="height: 552px; transform: translate3d(0px, 0px, 0px); display: block;"></div>
          </div>
        </div>

        <!-- Mail Detail Section -->
        <div class="mail-detail bg-white border-bottom p-3 w-100 simplebar-scrollable-y" data-simplebar="init" *ngIf="selectedFolder || selectedEmail">
          <div class="simplebar-wrapper">
            <div class="simplebar-height-auto-observer-wrapper">
              <div class="simplebar-height-auto-observer"></div>
            </div>
            <div class="simplebar-mask">
              <div class="simplebar-offset">
                <div class="simplebar-content-wrapper" tabindex="0" role="region" aria-label="scrollable content">
                  <div class="simplebar-content">
                    <div>

                      <div *ngIf="selectedFolder && !selectedEmail">
                        <div class="table-responsive mailbox-messages">
                          <table class="table table-hover">
                            <tbody>
                              <tr *ngFor="let email of getEmailsByFolder(selectedFolder)"
                                  (click)="selectEmail(email)">
                                <td class="mailbox-name">
                                  {{ selectedFolder === 'sent' ? buscarNome(email.destinatario) : buscarNome(email.remetente) }}
                                </td>
                                <td class="mailbox-subject">
                                  <b>{{ email.assunto }}</b> -
                                  {{ email.mensagem.substring(0, 30) }}...
                                </td>
                                <td class="mailbox-date">
                                  {{ email.dataCadastro | date:'dd/MM/yyyy HH:mm' }}
                                </td>
                              </tr>
                              <tr *ngIf="getEmailsByFolder(selectedFolder).length === 0">
                                <td colspan="3" class="text-center">Nenhum email encontrado</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <!-- Email detail when email is selected -->
                      <div *ngIf="selectedEmail">
                        <div class="bg-light card mb-3">
                          <div class="card-body">
                            <div class="d-flex align-items-center flex-fill border-bottom mb-3 pb-3">
                              <div class="fundo-iniciais m-lg-2">{{ buscarIniciais(buscarNome(selectedEmail.remetente)) }}</div>
                              <div class="flex-fill">
                                <div class="d-flex align-items-start justify-content-between flex-wrap row-gap-2">
                                  <div>
                                    <h6 class="fs-16 mb-1"><a href="javascript:void(0);">{{ buscarNome(selectedEmail.remetente) }}</a></h6>
                                    <p class="mb-0">Subject: {{ selectedEmail.assunto }}</p>
                                    <p class="mb-0 text-dark me-3"><span class="text-gray">To: </span> {{ buscarNome(selectedEmail.destinatario) }}</p>
                                  </div>
                                  <div class="d-flex align-items-center">
                                    <p class="me-2 mb-0">{{ selectedEmail.dataCadastro | date:'dd/MM/yyyy HH:mm' }} <i class="fa fa-calendar"></i></p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="d-flex align-items-center flex-wrap row-gap-2">

                            </div>
                            <div class="div">
                              <div>
                                <p class="text-dark">{{ selectedEmail.mensagem }}</p>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div class="card shadow-none">
                          <div class="card-header">
                            <h6 class="mb-0">Resposta</h6>
                          </div>
                          <div class="card-body">
                            <form action="#">
                              <div class="border rounded mt-3">
                                <div class="p-3 position-relative border-bottom">
                                  <div class="tag-with-img d-flex align-items-center">
                                    <label class="form-label me-2 mb-0">Para</label>
                                    <input type="text" class="form-control border-0" [value]="buscarNome(selectedEmail.remetente)">
                                  </div>
                                </div>
                                <div class="p-3">
                                  <div class="mb-3">
                                    <textarea rows="2" class="form-control border-0 p-0 bg-transparent shadow-none"></textarea>
                                  </div>
                                </div>
                                <div class="d-flex align-items-end pull-right justify-content-between border-top p-3 flex-wrap">
                                  <div class="d-flex align-items-end">
                                    <button type="submit" class="btn btn-primary d-inline-flex align-items-center ms-2">Enviar <i class="fa fa-arrow-right ms-2"></i></button>
                                  </div>
                                </div>
                              </div>
                            </form>
                          </div>
                        </div>

                        <div class="text-center">
                          <a href="javascript:void(0);" class="btn btn-dark btn-sm">View Older Messages</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="simplebar-placeholder"></div>
          </div>
          <div class="simplebar-track simplebar-horizontal" style="visibility: hidden;">
            <div class="simplebar-scrollbar" style="width: 0px; display: none;"></div>
          </div>
          <div class="simplebar-track simplebar-vertical" style="visibility: visible;">
            <div class="simplebar-scrollbar" style="height: 384px; transform: translate3d(0px, 0px, 0px); display: block;"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
